import config from "../config/config"
import { callService } from "./CommonService";

const APIUrlBase = config.apiHost + config.apiBase + 'users';

/* Retrieve one single user data */
async function getUser(userId) {
    const url = APIUrlBase + '/' + userId;
    return await callService(url);
}

/* Retrieve list of all of guest in the system */
async function getUsers() {
    const url = APIUrlBase;
    return await callService(url);
}

/* Call API service to create a user */
async function createUser(data) {
    const url = APIUrlBase;
    const method = 'POST';
    const payload = {
        name: `${data.name} ${data.lastname}`,
        email: data.email,
        password: "123456789",
        roleId: data.type === 'Administrador' ? 1 : 2,
        isActive: data.isActive,
    };
    return await callService(url, method, payload);
}

/* Call API service to create a user */
async function updateUser(userId, data) {
    const url = APIUrlBase + '/' + userId;
    const method = 'PATCH';
    const payload = {
        name: `${data.name}`,
        email: data.email,
        roleId: data.type === 'Administrador' ? 1 : 2,
        password: data.password,
        isActive: data.isActive,
    }
    return await callService(url, method, payload);
}

export default { getUsers, createUser, getUser, updateUser, };
